// extracted by mini-css-extract-plugin
export default {"breadcrumbsMultiItemsContainer":"G9J8vp"};